import React, { Suspense, useContext, useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { checkIsLoggedIn } from '~/utils/auth';
import OpenCashierOverlay from '../Cashier/components/OpenCashierOverlay';
import './style.css';
import { SessionExpiredModalContext } from '~/providers/SessionExpiredModalProvider';
import { setOpenModalFn } from '~/http/modal';
import RestaurantProvider from './providers/RestaurantProvider';
import { useAtomValue } from 'jotai';
import { restaurantAtom } from '~/store/restaurant';
import PermissionProvider from './providers/PermissionProvider';
import Loading from '../components/Loading';
import ErrorBoundary from '../ErrorBoundary';
import { permissionAtom } from '~/store/permission';
import Providers from './providers';

const useInitLayout = () => {
  const { openModalFn } = useContext(SessionExpiredModalContext);
  useEffect(() => {
    setOpenModalFn(openModalFn);
    return () => {
      setOpenModalFn(null);
    };
  }, []);
};

const Layout = () => {
  useInitLayout();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const restaurant = useAtomValue(restaurantAtom);
  const isPermissionLoaded = Boolean(useAtomValue(permissionAtom));

  useEffect(() => {
    checkIsLoggedIn().then((isLoggedIn) => {
      setIsLoggedIn(!!isLoggedIn);
      if (!isLoggedIn) {
        navigate('/login');
      }
    });
  }, []);

  if (!isLoggedIn) {
    return null;
  }

  // TODO tidy up
  return (
    <>
      <ErrorBoundary>
        <Suspense fallback={<Loading className="w-screen h-screen" />}>
          <RestaurantProvider />
          {restaurant ? (
            <>
              <PermissionProvider />
              {isPermissionLoaded ? (
                <Providers>
                  <div className="container" key={restaurant.restaurantId}>
                    <OpenCashierOverlay />
                    <Outlet />
                  </div>
                </Providers>
              ) : null}
            </>
          ) : null}
        </Suspense>
      </ErrorBoundary>
    </>
  );
};

export default Layout;
